import ControlKind from '../controlKind';
import JSONSchema7Properties from '../jSONSchema7Properties';
import PageState from '../pageState';

export default (pages: PageState[]): string[] => {
  const fields: string[] = [];

  pages.forEach((p) => {
    p.controls.forEach((c) => {
      if (c.kind === ControlKind.NUMERIC) {
        const properties = c.schema?.properties as JSONSchema7Properties;
        const configuredId = properties['id']?.default as string;
        fields.push(configuredId);
      }
    });
  });

  return fields.sort();
};
